import { configureStore } from "@reduxjs/toolkit";
import sidebarReducer from "../src/features/ui/sidebarSlice";

export const store = configureStore({
  reducer: {
    sidebar: sidebarReducer,
  },
});